// Metric scenarios represent lifecycle checkpoints we measure.
export var MetricScenario;
(function (MetricScenario) {
    MetricScenario["ApplicationLoad"] = "ApplicationLoad";
    MetricScenario["DatabaseLoad"] = "DatabaseLoad";
})(MetricScenario || (MetricScenario = {}));
